// DEPENDENCIES
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useFormik } from "formik";
// COMPONENTS
import Select from 'react-select';
import { Divider } from '@material-ui/core'
import { Link, useParams } from 'react-router-dom';
import { FilePond, registerPlugin } from "react-filepond";
import BlockUi from 'react-block-ui';
import MUIDataTable from "mui-datatables";
import moment from 'moment';
import { ModalProgressBar } from "../../../../_metronic/_partials/controls";
import { Modal, Button, InputGroup, FormControl, Container, Row, Col, Form } from "react-bootstrap";
// CUSTOM COMPONENTS
import * as alert from '../../../../redux/alertSnackBarRedux';
import * as confirmModal from '../../../../redux/confirmModalRedux';
// SERVICES AND HELPERS
import PLMDataHeaderValidator from '../../../../helpers/validators/PLMDataHeaderValidator';
import PLMDataLineItemValidator from '../../../../helpers/validators/PLMDataLineItemValidator';
import * as jobFormService from '../../../../services/service/jobFormService';
import * as haplmDataSheetService from '../../../../services/form/haplmDataSheetService';
import * as helper from "../../../../helpers/helper";
import constants from "../../../../constants/constants";
import set from 'date-fns/set';
//STYLES AND ASSETS

const initialState = {
    id: 0,
    inspectorId: 0,
    projectLocationId: null,
    date: new Date(),
    haplmDataSheetLineItems: []
}

const lineItemInitialState = {
    id: 0,
    sampleNumber: '',
    haNumber: '',
    description: '',
    location: '',
    approxQuantity: '',
    findings: ''
}

const HAPLMDataSheet = (props) => {
    const { showAlert, showConfirmModal, hideConfirmModal, setProcessing, history } = props;
    const { jobFormId } = useParams();
    const [loading, setLoading] = useState(false);
    const [haplmDataSheet, setHAPLMDataSheet] = useState(initialState);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [locationOptions, setLocationOptions] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [isReadOnly, setIsReadOnly] = useState(false);
    const [jobForm, setJobForm] = useState({
        id: 0,
        jobFormId: 0,
        projectNumber: "",
        client: "",
        name: "HA PLM Data Sheet",
        actualAssignedDate: new Date(),
        submittedById: 0,
        inspector: null,
        jobId: 0,
    });

    useEffect(() => {
        fetchJobLocations().then(res => {
            fetchHAPLMDataSheet(res);
        });
    }, [])

    const fetchJobLocations = () => jobFormService.getProposalProjectLocationsByJobFormId(jobFormId).then(res => {
        setLocationOptions(res);
        return res;
    });

    const fetchHAPLMDataSheet = (projectLocations) => {
        setLoading(true);
        haplmDataSheetService.getHAPLMDataSheetById(jobFormId).then(res => {
            if (res.haplmDataSheet.projectLocationId) {
                setSelectedLocation(projectLocations.find(x => x.value == res.haplmDataSheet.projectLocationId));
            }
            setIsReadOnly(res.submittedById !== 0);
            setJobForm(res);
            setHAPLMDataSheet(res.haplmDataSheet);
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' });
        }).finally(() => setLoading(false));
    }

    const columns = [
        {
            name: "id",
            label: "Actions",
            options: {
                filter: false,
                sort: false,
                width: 1,
                print: false,
                download: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            {!isReadOnly && <button
                                type="button"
                                href="#"
                                className="btn btn-sm btn-danger font-weight-bold py-2 px-3 px-xxl-5"
                                onClick={() => showConfirmModal({
                                    title: "Delete Line Item",
                                    text: "Are you sure you want to delete this line item?",
                                    rightBtnText: "Confirm",
                                    btnAction: () => removeLineItem(haplmDataSheet.haplmDataSheetLineItems[dataIndex].id)
                                })}
                            >
                                Delete
                            </button>}
                        </>
                    );
                }
            },

        },
        {
            name: "sampleNumber",
            label: "Sample #",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        {
            name: "haNumber",
            label: "HA #",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        {
            name: "description",
            label: "Description",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        {
            name: "location",
            label: "Location",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        {
            name: "approxQuantity",
            label: "Approx. Quantity",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        {
            name: "findings",
            label: "Findings",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        }
    ];

    const removeLineItem = (id) => {
        setProcessing();
        haplmDataSheetService.deleteLineItem(id).then(res => {
            let temp = [...haplmDataSheet.haplmDataSheetLineItems];
            temp.splice(temp.findIndex(x => x.id === id), 1);
            setHAPLMDataSheet({ ...haplmDataSheet, haplmDataSheetLineItems: temp });
            showAlert({ message: res.message, variant: 'success' })
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' })
        }).finally(() => {
            hideConfirmModal();
        })
    }

    const handleModalClose = () => {
        setIsModalOpen(false);
        formik_lineItem.resetForm();
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: haplmDataSheet,
        validationSchema: PLMDataHeaderValidator,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            setLoading(true);
            saveForm(values).finally(() => {
                setLoading(false);
                setSubmitting(false);
            });
        }
    });

    const formik_lineItem = useFormik({
        enableReinitialize: true,
        initialValues: lineItemInitialState,
        validationSchema: PLMDataLineItemValidator,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            setLoading(true);
            haplmDataSheetService.saveLineItem({ ...values, haplmDataSheetId: haplmDataSheet.id }).then(res => {
                let temp = [...haplmDataSheet.haplmDataSheetLineItems];
                temp.push({ ...values, id: res.id });
                setHAPLMDataSheet({ ...haplmDataSheet, haplmDataSheetLineItems: temp });
                showAlert({ message: res.message, variant: 'success' });
            }).catch(ex => {
                showAlert({ message: ex.message, variant: 'error' })
            }).finally(() => {
                setLoading(false);
                setSubmitting(false);
                handleModalClose();
            })
        }
    });

    const saveForm = (values) => {
        return haplmDataSheetService.save(values).then(res => {
            showAlert({ message: res.message, variant: 'success' })
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' })
        })
    }

    const submitForm = () => {
        formik.validateForm().then(res => {
            if (Object.keys(res).length > 0) {
                let err = "";
                for (const property in res) {
                    err += res[property] + ". ";
                }

                showAlert({ message: err + " Please save before submitting the form", variant: 'error' });
                return;
            }

            saveForm(formik.values).then(res => {
                jobFormService.submitForm(jobForm.id).then(res => {
                    showAlert({ message: res.message, variant: 'success' });
                    history.push("/services/manage-job/forms/" + jobForm.jobId);
                }).catch(ex => {
                    showAlert({ message: ex.message, variant: 'error' })
                })
            }).catch(ex => {
                showAlert({ message: ex.message, variant: 'error' })
            })
        })
    }

    return (
        <div className="card card-custom card-stretch">
            <Modal centered size="lg" show={isModalOpen} onHide={handleModalClose}>
                <form className="card card-custom" onSubmit={formik_lineItem.handleSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>Add Suspect Materials Sample Log</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form">
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Sample #
                                </label>
                                <div className="col-lg-9 col-xl-9">
                                    <input
                                        type="text"
                                        placeholder="Enter Sample Number"
                                        className={`form-control form-control-lg form-control-solid`}
                                        name="sampleNumber"
                                        {...formik_lineItem.getFieldProps("sampleNumber")}
                                    />
                                    {formik_lineItem.touched.sampleNumber && formik_lineItem.errors.sampleNumber ? (
                                        <div className="invalid-feedback" style={{ display: 'block' }}>
                                            {formik_lineItem.errors.sampleNumber}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    HA#
                                </label>
                                <div className="col-lg-9 col-xl-9">
                                    <input
                                        type="text"
                                        placeholder="Enter HA Number"
                                        className={`form-control form-control-lg form-control-solid`}
                                        name="haNumber"
                                        {...formik_lineItem.getFieldProps("haNumber")}
                                    />
                                    {formik_lineItem.touched.haNumber && formik_lineItem.errors.haNumber ? (
                                        <div className="invalid-feedback">
                                            {formik_lineItem.errors.haNumber}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Description
                                </label>
                                <div className="col-lg-9 col-xl-9">
                                    <Form.Control as="textarea" rows="5"
                                        placeholder="Enter Description"
                                        className={`form-control form-control-lg form-control-solid`}
                                        name="description"
                                        {...formik_lineItem.getFieldProps("description")}
                                    />
                                    {formik_lineItem.touched.description && formik_lineItem.errors.description ? (
                                        <div className="invalid-feedback">
                                            {formik_lineItem.errors.description}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Location
                                </label>
                                <div className="col-lg-9 col-xl-9">
                                    <input
                                        type="text"
                                        placeholder="Enter Location"
                                        className={`form-control form-control-lg form-control-solid`}
                                        name="location"
                                        {...formik_lineItem.getFieldProps("location")}
                                    />
                                    {formik_lineItem.touched.location && formik_lineItem.errors.location ? (
                                        <div className="invalid-feedback" style={{ display: 'block' }}>
                                            {formik_lineItem.errors.location}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Approx. Quantity
                                </label>
                                <div className="col-lg-9 col-xl-9">
                                    <input
                                        type="number"
                                        placeholder="Enter Approximate Quantity"
                                        className={`form-control form-control-lg form-control-solid`}
                                        name="approxQuantity"
                                        {...formik_lineItem.getFieldProps("approxQuantity")}
                                    />
                                    {formik_lineItem.touched.approxQuantity && formik_lineItem.errors.approxQuantity ? (
                                        <div className="invalid-feedback">
                                            {formik_lineItem.errors.approxQuantity}
                                        </div>
                                    ) : null}

                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Findings
                                </label>
                                <div className="col-lg-9 col-xl-9">
                                    <input
                                        type="text"
                                        placeholder="Enter Findings"
                                        className={`form-control form-control-lg form-control-solid`}
                                        name="findings"
                                        {...formik_lineItem.getFieldProps("findings")}
                                    />
                                    {formik_lineItem.touched.findings && formik_lineItem.errors.findings ? (
                                        <div className="invalid-feedback" style={{ display: 'block' }}>
                                            {formik_lineItem.errors.findings}
                                        </div>
                                    ) : null}

                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleModalClose}>
                            Close
                        </Button>
                        <button
                            type="submit"
                            className="btn btn-success mr-2"
                            disabled={
                                formik_lineItem.isSubmitting || (formik_lineItem.touched && !formik_lineItem.isValid)
                            }
                        >
                            Add
                            {formik_lineItem.isSubmitting}
                        </button>
                    </Modal.Footer>
                </form>
            </Modal>
            {loading && <ModalProgressBar />}
            <div className="card-header py-3">
                <div className="card-title align-items-start flex-column">
                    <h3 className="card-label font-weight-bolder text-dark">
                        HA PLM Data Sheet - ({moment(jobForm.actualAssignedDate).format("MM/DD/YYYY")})
                    </h3>
                    <span className="text-muted font-weight-bold fz-xs mt-1">
                        Please fill the form below
                    </span>
                </div>
                <div className="card-toolbar">
                    {!isReadOnly && <button
                        type="submit"
                        className={`btn btn-success mr-2`}
                        disabled={
                            formik.isSubmitting || (formik.touched && !formik.isValid)
                        }
                        onClick={() => submitForm()}
                    >
                        Submit Form
                        {formik.isSubmitting}
                    </button>}
                    <Link
                        to={"/services/manage-job/forms/" + jobForm.jobId}
                        className="btn btn-danger"
                    >
                        Cancel
                    </Link>
                </div>
            </div>
            <div className="form">
                <form className="card card-custom" onSubmit={formik.handleSubmit}>
                    <fieldset disabled={isReadOnly}>
                        <div className="card-body">
                            <Row>
                                <Col>
                                    <div className="form-group row">
                                        <label className="col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                            Date
                                        </label>
                                        <div className="col-xl-6">
                                            <input
                                                readOnly
                                                type="text"
                                                placeholder="08/09/2021"
                                                className={`form-control form-control-lg form-control-solid`}
                                                name="date"
                                                value={moment(haplmDataSheet.date).format("MM/DD/YYYY")}
                                            />
                                        </div>
                                    </div>
                                </Col>
                                <Col>
                                    <div className="form-group row">
                                        <label className="col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                            AES Project#
                                        </label>
                                        <div className="col-xl-6">
                                            <input
                                                readOnly
                                                type="text"
                                                placeholder="21-0003-01"
                                                className={`form-control form-control-lg form-control-solid`}
                                                name="name"
                                                value={jobForm.projectNumber}
                                            />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className="form-group row">
                                        <label className="col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                            Client
                                        </label>
                                        <div className="col-xl-6">
                                            <input
                                                readOnly
                                                type="text"
                                                placeholder="Primtek LLC"
                                                className={`form-control form-control-lg form-control-solid`}
                                                name="client"
                                                value={jobForm.client}
                                            />
                                        </div>
                                    </div>
                                </Col>
                                <Col>
                                    <div className="form-group row">
                                        <label className="col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                            Inspector
                                        </label>
                                        <div className="col-xl-6">
                                            <input
                                                readOnly
                                                type="text"
                                                placeholder="Bibesh KC"
                                                className={`form-control form-control-lg form-control-solid`}
                                                name="name"
                                                value={jobForm.inspector}
                                            />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className="form-group row">
                                        <label className="col-form-label col-xl-2 col-lg-2 col-form-label fz-mdsm fw-600">
                                            Project Location
                                        </label>
                                        <div className="col-xl-10">
                                            <Select
                                                value={selectedLocation}
                                                options={locationOptions}
                                                onChange={selectedOption => {
                                                    selectedOption = selectedOption === null ? [] : selectedOption;
                                                    setSelectedLocation(selectedOption);
                                                    formik.setFieldValue("projectLocationId", selectedOption.value);
                                                }}
                                                className={`${helper.getInputClasses(formik, "projectLocationId")}`}
                                                name="projectTypeId"
                                                placeholder="Select Project Location"
                                            />
                                            {formik.touched.projectLocationId && formik.errors.projectLocationId ? (
                                                <div className="invalid-feedback">
                                                    {formik.errors.projectLocationId}
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <div className="d-flex justify-content-between">
                                <div className="d-flex">
                                    <h5 className="mt-lg-10 mb-6 fz-md fw-700 c-primary">Suspect Materials Sample Log</h5>
                                </div>
                                {
                                    !isReadOnly &&
                                    <div className="d-flex align-items-center">
                                        <button
                                            type="button"
                                            onClick={() => setIsModalOpen(true)}
                                            className="btn btn-info mr-2 fit-content"

                                        >
                                            Add Log
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn btn-primary mr-2 fit-content"
                                            disabled={
                                                formik.isSubmitting || (formik.touched && !formik.isValid)
                                            }
                                        >
                                            Save Form
                                            {formik.isSubmitting}
                                        </button>
                                    </div>
                                }
                            </div>
                            <Divider />
                            <MUIDataTable
                                data={haplmDataSheet.haplmDataSheetLineItems}
                                columns={columns}
                                options={{
                                    selectableRows: 'none',
                                }}
                            />
                        </div>
                    </fieldset>
                </form>
            </div>
        </div>
    )
}

export default connect(null, {
    ...alert.actions,
    ...confirmModal.actions
})(HAPLMDataSheet);